import { ConfigProvider, Layout, Menu } from 'antd'
import { jwtDecode } from "jwt-decode"
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import API from '../config/api'
import { logout } from '../redux/slices/userSlice'
import RetailProduct from '../retailExpress/product'
import Report from '../retailExpress/report'
import BranchReport from '../screens/BranchReport'
import ProductWiseReport from '../screens/productWiseReport'
import HomeScreen from '../pages/homeScreen'
import { GET } from '../utils/apiCalls'
import SideBar from './sideBar'
import { HomeOutlined, PieChartOutlined, ShopOutlined, ProductOutlined } from '@ant-design/icons';

function Navigation() {
    const { user } = useSelector((state: any) => state.User);
    const token: any = user.token;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { Sider, Content, Footer, Header } = Layout;

    const [collapsed, setCollapsed] = useState(true);
    const [current, setCurrent] = useState(location.pathname);
    const [mobileMenuVisible, setMobileMenuVisible] = useState(false);

    useEffect(() => {
        setCurrent(location.pathname);
    }, [location.pathname]);

    const signoutUser = () => {
        dispatch(logout({}))
        navigate("/");
        return;
    };

    useEffect(() => {
        const checkTokenExpiration = () => {
            if (token) {
                const decoded: any = jwtDecode(token);
                let currentDate = new Date();
                if (decoded.exp && decoded.exp * 1000 < currentDate.getTime()) {
                    signoutUser();
                }
            }
        };

        checkTokenExpiration();
        const interval = setInterval(checkTokenExpiration, 5000);

        return () => clearInterval(interval);
    }, [token, signoutUser]);

    const handleMenuClick = (e: any) => {
        navigate(e.key);
    };

    const handleMobileMenuToggle = () => {
        setMobileMenuVisible(!mobileMenuVisible);
    };

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: "#36b372",
                    fontFamily: "Regular",
                    borderRadius: 4,
                    colorTextPlaceholder: "#888c99",
                },
            }}
        >
            <Layout style={{ minHeight: '100vh' }}>
                <Sider 
                    className='d-none d-lg-block'
                    style={{ 
                        backgroundColor: "#fff", 
                        borderRight: '1px solid #dedede', 
                        height: '100vh', 
                        overflow: 'scroll',
                        position: 'fixed',
                        left: 0,
                        top: 0,
                        zIndex: 1001
                    }}
                    width={collapsed ? 250 : 80}
                >
                    <SideBar collapsedChane={() => setCollapsed(!collapsed)} collapsed={collapsed} />
                </Sider>
                
                <Layout
                    style={{ 
                        backgroundColor: "#fff", 
                        borderRight: '1px solid #dedede', 
                        marginLeft: collapsed ? 250 : 80,
                        transition: 'margin-left 0.2s ease'
                    }}
                >
                   
                    
                    <Content
                        style={{ 
                            background: "#f6f4f0", 
                            overflow: "auto",
                            minHeight: 'calc(100vh - 70px)'
                        }}
                    >
                        <Routes>
                            <Route path="/dashboard" element={<HomeScreen />} />
                            <Route path="/product" element={<RetailProduct />} />
                            <Route path="/report" element={<Report />} />
                            <Route path="/branch-report" element={<BranchReport />} />
                            <Route path="/product-wise-report" element={<ProductWiseReport />} />
                            <Route path="*" element={<Navigate to="/auth/dashboard" replace />} />
                        </Routes>
                    </Content>
                    
                    <Footer 
                        className="d-block d-lg-none" 
                        style={{ 
                            padding: 0, 
                            position: 'fixed', 
                            bottom: 0, 
                            width: '100%', 
                            borderTop: '1px solid #dedede', 
                            backgroundColor: '#fff',
                            zIndex: 1000
                        }}
                    >
                        <Menu 
                            mode="horizontal" 
                            selectedKeys={[current]} 
                            onClick={handleMenuClick} 
                            style={{ 
                                display: 'flex', 
                                justifyContent: 'space-around', 
                                borderBottom: 'none' 
                            }}
                        >
                            <Menu.Item key="/home" icon={<HomeOutlined />}>
                                <span className="menu-item-text">Home</span>
                            </Menu.Item>
                            <Menu.Item key="/report" icon={<PieChartOutlined />}>
                                <span className="menu-item-text">Reports</span>
                            </Menu.Item>
                            <Menu.Item key="/branch-report" icon={<ShopOutlined />}>
                                <span className="menu-item-text">Branches</span>
                            </Menu.Item>
                            <Menu.Item key="/product" icon={<ProductOutlined />}>
                                <span className="menu-item-text">Products</span>
                            </Menu.Item>
                        </Menu>
                    </Footer>
                </Layout>
            </Layout>
        </ConfigProvider>
    )
}

export default Navigation